module.exports = __webpack_public_path__ + "static/media/banner-du-lich.aae45adb.jpg";